import { z } from "zod";

export const patientSchema = z.object({
  name: z.string().min(2, "El nombre debe tener al menos 2 caracteres"),
  email: z.string().email("Email invalido").or(z.literal("")),
  phone: z.string().optional(),
  date_of_birth: z.string().optional(),
  gender: z.string().optional(),
  occupation: z.string().optional(),
  emergency_contact_name: z.string().optional(),
  emergency_contact_phone: z.string().optional(),
  medical_history: z.string().optional(),
  allergies: z.string().optional(),
  notes: z.string().optional(),
});

export const appointmentSchema = z.object({
  patient_id: z.string().min(1, "Selecciona un paciente"),
  start_time: z.string().min(1, "Hora de inicio requerida"),
  end_time: z.string().min(1, "Hora de fin requerida"),
  notes: z.string().optional(),
}).refine((data) => data.start_time < data.end_time, {
  message: "La hora de fin debe ser posterior al inicio",
  path: ["end_time"],
});

export const episodeSchema = z.object({
  title: z.string().min(2, "El titulo debe tener al menos 2 caracteres"),
  chief_complaint: z.string().optional(),
});

export const evaluationSchema = z.object({
  subjective: z.string().min(3, "El campo subjetivo es requerido (min 3 caracteres)"),
  objective: z.string().min(3, "El campo objetivo es requerido (min 3 caracteres)"),
  assessment: z.string().min(3, "La evaluacion es requerida (min 3 caracteres)"),
  plan: z.string().min(3, "El plan es requerido (min 3 caracteres)"),
  pain_level: z.number().min(0).max(10),
  rom_notes: z.string().optional(),
  strength_notes: z.string().optional(),
  functional_notes: z.string().optional(),
  goals: z.string().optional(),
  frequency: z.string().optional(),
});

export const sessionNoteSchema = z.object({
  subjective: z.string().min(3, "El campo subjetivo es requerido"),
  objective: z.string().optional(),
  interventions: z.string().min(3, "Las intervenciones son requeridas"),
  patient_response: z.string().optional(),
  progress_notes: z.string().optional(),
  next_session_plan: z.string().optional(),
  pain_level: z.number().min(0).max(10),
});

export const exercisePlanSchema = z.object({
  title: z.string().min(2, "El titulo es requerido"),
  description: z.string().optional(),
  exercises: z.array(z.object({
    name: z.string().min(1, "El nombre del ejercicio es requerido"),
    description: z.string().optional(),
    sets: z.number().min(1, "Minimo 1 serie"),
    reps: z.number().min(1, "Minimo 1 repeticion"),
    frequency: z.string().optional(),
    hold_seconds: z.number().optional(),
    notes: z.string().optional(),
  })).min(1, "Agrega al menos un ejercicio con nombre"),
});

export const paymentSchema = z.object({
  patient_id: z.string().min(1, "Selecciona un paciente"),
  amount: z.number().positive("El monto debe ser mayor a 0"),
  method: z.string().min(1, "Selecciona un metodo de pago"),
  notes: z.string().optional(),
});

export function validate(schema, data) {
  const result = schema.safeParse(data);
  if (result.success) return { ok: true, data: result.data, errors: {} };
  const errors = {};
  result.error.errors.forEach((e) => {
    const key = e.path.join(".");
    if (!errors[key]) errors[key] = e.message;
  });
  return { ok: false, data: null, errors };
}
